import { Action } from '@ngrx/store';

export enum ReceiveDocumentLinkActionTypes {
  RECEIVE_DOCUMENT_GET_LINK = '[Orders] Receive Document Get Link',
  RECEIVE_DOCUMENT_GET_LINK_SUCCESS = '[Orders] Receive Document Get Link Success',
  RECEIVE_DOCUMENT_GET_LINK_FAILURE = '[Orders] Receive Document Get Link Failure',
  CLEAR_RECEIVE_DOCUMENT = '[Orders] Clear Receive Document',
}

export class ReceiveDocumentGetLink implements Action {
  readonly type = ReceiveDocumentLinkActionTypes.RECEIVE_DOCUMENT_GET_LINK;

  constructor(public payload: any) {
  }
}

export class ReceiveDocumentGetLinkSuccess implements Action {
  readonly type = ReceiveDocumentLinkActionTypes.RECEIVE_DOCUMENT_GET_LINK_SUCCESS;

  constructor(public payload: any) {
  }
}

export class ReceiveDocumentGetLinkFailure implements Action {
  readonly type = ReceiveDocumentLinkActionTypes.RECEIVE_DOCUMENT_GET_LINK_FAILURE;

  constructor(public payload: any) {
  }
}

export class ClearReceiveDocumentState implements Action {
  readonly type = ReceiveDocumentLinkActionTypes.CLEAR_RECEIVE_DOCUMENT;
}

export type ReceiveDocumentLinkActions =
  ReceiveDocumentGetLink |
  ReceiveDocumentGetLinkSuccess |
  ReceiveDocumentGetLinkFailure |
  ClearReceiveDocumentState;
